import angular from 'angular';

module.exports = angular.module('common.services.hoa-frequencies', [])
.factory('HOA_FREQUENCIES', function() {
  return [
    'One-off',
    'Monthly',
    'Quarterly',
    'Semi-Annually',
    'Annually'
  ];
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/hoa-frequencies.js
 **/